__turbopack_context__.v({
  "container": "O8JpJG_container",
  "language_switcher": "O8JpJG_language_switcher",
  "language_switcher_wrap": "O8JpJG_language_switcher_wrap",
  "logo": "O8JpJG_logo",
  "main": "O8JpJG_main",
  "main_left": "O8JpJG_main_left",
  "main_space": "O8JpJG_main_space",
  "menu_desktop": "O8JpJG_menu_desktop",
  "menu_item": "O8JpJG_menu_item",
  "menu_mobile": "O8JpJG_menu_mobile",
  "right": "O8JpJG_right",
  "right_split": "O8JpJG_right_split",
  "split": "O8JpJG_split",
  "title": "O8JpJG_title",
  "title_link": "O8JpJG_title_link",
});
